import { render, staticRenderFns } from "./OrganizationPartnerships.vue?vue&type=template&id=3aa23f3f&"
import script from "./OrganizationPartnerships.vue?vue&type=script&lang=js&"
export * from "./OrganizationPartnerships.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationPartnerships.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports